import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import DotSeparatedElements from "../../dot_separated_elements";
import UserProfileLink from "../../user/user_profile_link";
import { compact } from "lodash";

export default GrComponentFactory.createClass({
  displayName: "ReviewMetaDetails",

  propTypes: {
    readAtText: React.PropTypes.string,
    recommendedByUser: GrPropTypes.user(),
  },

  renderReaderText(){
    return this.props.readAtText ?
      this.props.readAtText
      : null;
  },

  renderRecommendedByUserInfo(){
    return this.props.recommendedByUser ?
      <span>
        {"Recommended by "}
        <UserProfileLink user={this.props.recommendedByUser}/>
      </span>
      : null;
  },

  getReviewDetailElements() {
    return compact([
      this.renderReaderText(),
      this.renderRecommendedByUserInfo(),
    ]);
  },

  render() {
    return (
      <div className="gr-metaText">
        <DotSeparatedElements elements={this.getReviewDetailElements()} />
      </div>
    );
  },
});
